<template>
  <div>
    <Header></Header>
    <div class="container album-container">
      <div class="row">
        <div class="col-12 bread-crumbs">
          <router-link to="/events/">События</router-link>/
          <router-link to="/events/">Управление фотографиями</router-link>
        </div>
        <h1>Управление фотографиями</h1>
      </div>
      <div class="row">
        <div class="drop-zone-wrap col-12">
          <vue2Dropzone
            ref="dropzone"
            id="dropzone_album"
            :options="loadPicOpt"
            :useCustomSlot="true"
            @vdropzone-success="successLoad"
            @vdropzone-files-added="added"
            @vdropzone-error="errorLoad"
          >
            <div class="dropzone-custom-content">
              <div class="subtitle">Загрузить изображение</div>
              <div class="files-preview-wrap"></div>
            </div>
          </vue2Dropzone>
        </div>
      </div>

      <draggable v-model="album.files" class="preview-zone">
        <div class="pic-preview-wrap" v-for="(pic,index) in album.files" :key="index" ref="file">
          <div class="wrapper">
            <div class="bg" :style="bg(pic.url)"></div>
            <div class="errore-pic" @click="removePic(index)" @click.stop>
              <SvgIcon name="error_outline" width="24px" height="24px" fill="#fff"></SvgIcon>
            </div>
            <div class="picture_control">
              <div class="remove-pic" @click="removePic(index)" @click.stop>
                <SvgIcon name="delete" width="24px" height="24px" fill="#fff"></SvgIcon>
              </div>
            </div>
          </div>
        </div>
      </draggable>
      <div class="btn-wrap">
        <button class="btn btn-primary" @click="saveFiles">Сохранить</button>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import { DropZoneBaseOptions } from "@/library/lib.js";
import vue2Dropzone from "vue2-dropzone";
import _ from "lodash";
import { mapGetters } from "vuex";
import draggable from "vuedraggable";
import place_h_link from "@/assets/file_place_holder.png";

export default {
  name: "PicturesList",
  components: { Header, vue2Dropzone, draggable },
  data() {
    return {
      album: {},
      loadPicOpt: {
        ...new DropZoneBaseOptions(),
        maxFiles: 500
      },
      bg: function(url) {
        return `background:url(${url})`;
      }
    };
  },
  methods: {
    removePic: function(ind) {
      this.album.files.splice(ind, 1);
    },
    added: function(file) {
      if (!file.length) return;

      if (!Array.isArray(file)) {
        for (let key in file) {
          if (key === "length") return;

          file[key].ind = this.album.files.length;
          this.album.files.push({
            id: file[key].ind,
            url: place_h_link,
            ind: file[key].ind
          });
        }
      } else {
        file.forEach(_file => {
          _file.ind = this.album.files.length;
          this.album.files.push({
            id: _file.ind,
            url: place_h_link,
            ind: _file.ind
          });
        });
      }
    },
    successLoad: function(file, response) {
      let index = this.album.files.findIndex(elem => elem.ind === file.ind);
      if (index > -1) {
        this.album.files[index].id = response.id;
        this.album.files[index].url = response.url;
      }
    },
    errorLoad: function(file, message) {
      if (this.$refs.file[file.ind]) {
        let err_file = this.$refs.file[file.ind];
        err_file.classList.add("erroreLoad");
        err_file
          .getElementsByClassName("errore-pic")[0]
          .setAttribute("erroremessage", message.message);
      }
    },
    thumbGened: function() {},
    saveFiles: function() {
      let complete = true;
      this.$refs.dropzone.dropzone.files.forEach(_file => {
        if (_file.status === "uploading") complete = false;
      });
      if (!complete) return;

      this.$store.dispatch("files/saveAlbum", this.album).then(()=>{
        this.$router.push({path:'/events/edit/'+this.album.event_id+'/'});
      })
    }
  },
  mounted() {
    this.$store.dispatch("files/loadAlbum", this.$route.params.eventId);
  },
  computed: {
    ...mapGetters({
      get_album: "files/get_album"
    })
  },
  watch: {
    get_album: function(a) {
      this.album = _.cloneDeep(a);
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-wrap {
  text-align: center;
}
.btn {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  padding: 16px 100px;
  display: inline-block;
}
.album-container {
  padding-top: 32px;
  h1 {
    margin-top: 10px;
    font-weight: bold;
    font-size: 32px;
    line-height: 40px;
    margin-bottom: 56px;
  }
  .preview-zone {
    margin: 60px 0;
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    grid-row-gap: 15px;
    grid-column-gap: 15px;
    transition: all 3s cubic-bezier(0.39, 0.575, 0.565, 1);

    .pic-preview-wrap {
      position: relative;
      width: 100px;
      height: 100px;
      .wrapper {
        border-radius: 20px;
        overflow: hidden;
        @include border();
        cursor: pointer;
        transition: all 3s cubic-bezier(0.39, 0.575, 0.565, 1);
      }

      &:hover {
        .picture_control {
          display: flex;
        }
      }
      &.erroreLoad {
        .errore-pic {
          display: block;
        }
      }

      .errore-pic {
        padding: 4px;
        display: none;
        position: absolute;
        z-index: 12;
        color: #eb4b4b;
        cursor: pointer;
        &:hover {
          &::after {
            content: attr(erroremessage);
            display: flex;
            color: $mainColor;
            background: #fff;
            min-width: 150px;
            max-width: 300px;
            @include border($mainColor);
            top: -46px;
            left: 0;
            position: absolute;
            padding: 5px 15px;
          }
          &::before {
            content: "";
            position: absolute;
            top: -10px;
            left: 30px;
            border: 6px solid $mainColor;
            border-left-color: transparent;
            border-right-color: transparent;
            border-bottom-color: transparent;
          }
        }
      }

      .picture_control {
        position: absolute;
        padding: 5px;
        justify-content: flex-end;
        align-items: top;
        color: #fff;
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;
        display: none;
        .change-pic,
        .remove-pic {
          width: 40px;
          height: 40px;
          flex: 0 0 40px;
          border-radius: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }
        .change-pic {
          background: $mainColor;
          margin-right: 8px;
        }
        .remove-pic,
        .erroreLoad {
          background: #eb4b4b;
        }
      }
      .bg {
        position: absolute;
        left: 0;
        top: 0;
        background-repeat: no-repeat !important;
        background-position: center !important;
        background-size: cover !important;
        width: 100%;
        height: 100%;
      }
    }
  }

  #dropzone_album {
    width: 100%;
    height: 100%;
    height: 200px;
    color: $mainColor;
    display: flex;
    align-items: center;
    justify-content: center;
    @include border($mainColor);
    border-style: dashed;

    .files-preview-wrap {
      $p_dding: 5px;
      overflow: auto;
      width: calc(100% - #{$p_dding} * 2);
      height: calc(100% - #{$p_dding} * 2);
      top: $p_dding;
      left: $p_dding;
      position: absolute;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-row-gap: 15px;

      flex-wrap: wrap;

      .file-preview {
        position: relative;
        @include border($calmColor);
        max-width: 115px;
        flex: 0 0 115px;
        height: 115px;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        &:hover {
          .picture_control {
            display: flex;
          }
        }
        .picture_control {
          position: absolute;
          justify-content: center;
          align-items: center;
          color: #fff;
          top: 0;
          right: 0;
          width: 100%;
          height: 100%;
          display: none;
          .change-pic,
          .remove-pic {
            width: 40px;
            height: 40px;
            flex: 0 0 40px;
            border-radius: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
          }
          .change-pic {
            background: $mainColor;
            margin-right: 8px;
          }
          .remove-pic {
            background: #eb4b4b;
          }
        }
      }
    }
  }
}
</style>
